import React from "react";

import Image from "next/image";

import Link from "next/link";
import { Development } from "@/services/cms/apiTypes";
import { formatPrice } from "@/utils/formatPrice";

const NeighbourHoodIntrestCard = ({ development }: { development?: Development }) => {
  if (!development) {
    return null;
  }

  const { title, beds, description, availableOn, rent, price, cover, neighbourhood } =
    development.attributes;
  const coverUrl =
    cover?.data?.attributes?.formats?.small?.url || cover?.data?.attributes?.url || "";
  const neighbourhoodUrl = `/properties/${neighbourhood?.data?.attributes?.slug || ""}`;
  return (
    <div
      className="flex flex-col h-full group relative z-0 bg-[#FBFCF1] shadow-card hover:shadow-card-hover hover:-translate-y-1 transition-all duration-300 rounded-[15px]"
      role="tab"
    >
      <Link href={neighbourhoodUrl}>
        <a
          className="block w-full h-full no-underline"
          style={{ WebkitTapHighlightColor: "transparent" }}
        >
          <div className="flex  flex-col overflow-hidden cursor-pointer hover:opacity-90 transition-opacity w-full h-full">
            {/* Image Section with Ribbon */}
            <div className="flex w-full relative">
              <div className="w-full relative">
                <div className="w-full pb-[66.6667%] relative ">
                  <Image
                    src={coverUrl}
                    alt={title || ""}
                    className="rounded-tl-[15px] rounded-tr-[15px] "
                    layout="fill"
                    priority
                    loading="eager"
                    objectFit="cover"
                  />
                </div>
              </div>
              {/* Coming Soon Ribbon */}
              <div className="absolute w-1/2 h-2/3">
                <Image
                  src="/icons/new-coming-soon-ribbon.png"
                  alt="Coming Soon"
                  layout="fill"
                  className="object-contain object-left-top"
                  priority
                />
              </div>
            </div>

            {/* Content Section */}
            <div className="flex flex-col px-3 py-3 grow justify-between">
              {/* Title */}
              <h3 className="text-center t xl:text-[30px] lg:text-[28px] md:text-[26px] sm:text-[24px] text-[22px] leading-9 font-semibold w-full line-clamp-2 ">
                {title || ""}
                <br />
                Coming
                <span className="text-landing-orange">{` ${availableOn || ""}`}</span>
              </h3>

              {/* Bedroom Info */}
              <div className="hidden md:flex flex-row justify-center items-center mb-2 mt-2">
                <div className="w-[50.29px] relative mr-2.5 h-[33px]">
                  <Image
                    src="/icons/bedroom.svg"
                    alt="Bedroom"
                    layout="fill"
                    objectFit="contain"
                    priority
                  />
                </div>
                <div className="xl:text-[32px] lg:text-[30px] md:text-[28px] sm:text-[26px] text-[24px]  ">
                  {beds || ""}
                </div>
              </div>

              {/* Pricing Info */}
              <div className="hidden md:block mb-2">
                <p className="text-[16px] md:text-[18px] leading-relaxed  font-semibold line-clamp-1">
                  Rents starting from {formatPrice(Number(rent || 0))} per month
                </p>
                <p className="text-[16px] md:text-[18px] leading-relaxed  font-semibold line-clamp-1 -mt-1">
                  Option to buy homes from {formatPrice(Number(price || 0))}
                </p>
              </div>

              {/* Description */}
              <div className="hidden md:block mb-3">
                <p className="text-[14px] md:text-[16px] line-height-[23px] leading-[23px] line-clamp-4">
                  {description || ""}
                </p>
              </div>

              {/* CTA Button */}
              <div className="flex justify-center mt-4 sm:mt-0 mb-2 sm:mb-0 ">
                <button className="px-4 py-3 bg-landing-orange text-white text-[16px]  font-bold rounded-lg shadow-md hover:scale-105 transition duration-300 ease-in-out transform">
                  Find out more
                </button>
              </div>
            </div>
          </div>
        </a>
      </Link>
    </div>
  );
};

export default NeighbourHoodIntrestCard;
